import gql from 'graphql-tag';

export const PEOPLE_EMPLOYEE_EVENT_FRAGMENT = gql`
	fragment peopleEmployeeEvent on EmployeeEvent {
		id
		type
		occurredAt
		summary
		details
		actionsTaken
		isConfidential
		employee {
			id
			firstName
			lastName
			preferredName
			personalEmail
			position {
				id
				name
				eventsRequireReview
			}
			workTenant {
				id
				name
			}
		}
		involvedEmployees {
			id
			firstName
			lastName
			preferredName
			personalEmail
			position {
				id
				name
				eventsRequireReview
			}
			workTenant {
				id
				name
			}
		}
		attachments {
			id
			title
			files {
				key
				s3Key
				mimeType
				sizeBytes
				sha256
			}
		}
		voidedAt
		voidedBy {
			id
			firstname
			lastname
			username
		}
		voidReason
		reviewRequired
		effectiveReviewer {
			id
			firstname
			lastname
			username
		}
		reviewer {
			id
			firstname
			lastname
			username
		}
		reviewStatus
		reviewStatusLabel
		reviewedAt
		reviewedBy {
			id
			firstname
			lastname
			username
		}
		reviewNotes
		created
		creator {
			id
			firstname
			lastname
		}
		creatorEmployee {
			id
			firstName
			lastName
			preferredName
			personalEmail
		}
	}
`;

export const GET_EMPLOYEE_EVENT = gql`
	query($id: ID!) {
		getEmployeeEvent(id: $id) {
			...peopleEmployeeEvent
		}
	}
	${PEOPLE_EMPLOYEE_EVENT_FRAGMENT}
`;

export const GET_EMPLOYEE_EVENTS = gql`
	query(
		$employeeId: ID,
		$page: Int,
		$perPage: Int,
		$sortBy: String!,
		$sortDirection: Int!,
		$filter: EmployeeEventFilter
	) {
		getEmployeeEvents(
			employeeId: $employeeId,
			page: $page,
			perPage: $perPage,
			sortBy: $sortBy,
			sortDirection: $sortDirection,
			filter: $filter
		) {
			items {
				...peopleEmployeeEvent
			}
			count
		}
	}
	${PEOPLE_EMPLOYEE_EVENT_FRAGMENT}
`;

export const COUNT_EMPLOYEE_EVENTS = gql`
	query($filter: EmployeeEventFilter) {
		countEmployeeEvents(filter: $filter)
	}
`;

export const GET_EMPLOYEE_EVENT_REVIEWERS = gql`
	query(
		$forFilter: Boolean,
		$page: Int,
		$perPage: Int,
		$sortBy: String!,
		$sortDirection: Int!,
		$filter: EmployeeEventReviewerFilter
	) {
		getEmployeeEventReviewers(
			forFilter: $forFilter,
			page: $page,
			perPage: $perPage,
			sortBy: $sortBy,
			sortDirection: $sortDirection,
			filter: $filter
		) {
			items {
				id
				firstname
				lastname
				username
			}
			count
		}
	}
`;

export const CREATE_EMPLOYEE_EVENT = gql`
	mutation createEmployeeEvent($input: CreateEmployeeEventInput!) {
		createEmployeeEvent(input: $input) {
			...peopleEmployeeEvent
		}
	}
	${PEOPLE_EMPLOYEE_EVENT_FRAGMENT}
`;

export const REPORT_MY_EMPLOYEE_EVENT = gql`
	mutation reportMyEmployeeEvent(
		$type: Int!,
		$occurredAt: Date,
		$summary: String,
		$details: String,
		$isConfidential: Boolean,
		$attachments: [ID]
	) {
		reportMyEmployeeEvent(
			type: $type,
			occurredAt: $occurredAt,
			summary: $summary,
			details: $details,
			isConfidential: $isConfidential,
			attachments: $attachments
		) {
			id
		}
	}
`;

export const MODIFY_EMPLOYEE_EVENT = gql`
	mutation modifyEmployeeEvent($input: ModifyEmployeeEventInput!) {
		modifyEmployeeEvent(input: $input) {
			employeeEvent: employeeevent {
				...peopleEmployeeEvent
			}
		}
	}
	${PEOPLE_EMPLOYEE_EVENT_FRAGMENT}
`;

export const VOID_EMPLOYEE_EVENT = gql`
	mutation voidEmployeeEvent($id: ID!, $reason: String!) {
		voidEmployeeEvent(id: $id, reason: $reason) {
			...peopleEmployeeEvent
		}
	}
	${PEOPLE_EMPLOYEE_EVENT_FRAGMENT}
`;
